import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;


// configure the class for runtime loading
if (!window.fbControls) window.fbControls = new Array();
window.fbControls.push(function (controlClass) {
  /**
   * User data
   */
  class comandaData extends controlClass {

    static get definition() {
      return {
        icon: '📄',
        i18n: {
          default: 'Dados da Comanda'
        }
      }
    }

    configure() {

    }

    /**
     * build a text DOM element, supporting other jquery text form-control's
     * @return DOM Element to be injected into the form.
     */
    build() {
        let table = ""
        let table_header = "<table style='border: 1px solid #ddd;'><tr>"
        if(this.config.dataAtendimento != ("" || undefined)){
            table_header += "<th style='text-align: center; border: 1px solid #ddd; padding: 5px;'>Data de Atendimento</th>"
        }
        if(this.config.horaAtendimento != ("" || undefined)){
            table_header += "<th style='text-align: center; border: 1px solid #ddd; padding: 5px;'>Horário de Atendimento</th>"
        }
        if(this.config.numComanda != ("" || undefined)){
            table_header += "<th style='text-align: center; border: 1px solid #ddd; padding: 5px;'>Número da Comanda</th>"
        }
        if(this.config.servico != ("" || undefined)){
            table_header += "<th style='text-align: center; border: 1px solid #ddd; padding: 5px;'>Serviço</th>"
        }
        if(this.config.franquia != ("" || undefined)){
            table_header += "<th style='text-align: center; border: 1px solid #ddd; padding: 5px;'>Franquia</th>"
        }
        if(this.config.profissionalResponsavel != ("" || undefined)){
            table_header += "<th style='text-align: center; border: 1px solid #ddd; padding: 5px;'>Profissional Responsável</th>"
        } 
        table_header += "</tr>"

        // Arrumar essa parte ai de cima que isso tá ridículo

        let table_contents = "<tr>"
        let objetoAuxiliar = this.config
        
        delete objetoAuxiliar.className
        delete objetoAuxiliar.name
        delete objetoAuxiliar.type
        delete objetoAuxiliar.id
        
        Object.entries(objetoAuxiliar).forEach(x => {
            table_contents += "<td style='text-align: center; border: 1px solid #ddd; padding: 5px;'>"+ x[1] +"</td>"
        });


        table_contents += "</tr style='border: 1px solid #ddd;'></table>"
        table = table_header+=table_contents

        return table
    } 

    onRender() {
        //
    }

  }

  // register this control for the following types & text subtypes
  controlClass.register('comandaData', comandaData);
  return comandaData;
});
